import { Link } from 'react-router-dom';
import { ShieldAlert, ArrowLeft, Phone } from 'lucide-react';
import SEO from '../components/SEO';

export default function Error403() {
  return (
    <>
      <SEO title="Adgang nægtet (403) | Thai Hot Chili" />

      <section className="min-h-screen flex items-center justify-center pt-24 pb-16 bg-brand-cream text-brand-dark">
        <div className="max-w-xl mx-auto px-6 text-center flex flex-col items-center gap-6 bg-white p-10 sm:p-12 rounded-3xl border border-gray-100 shadow-xl">
          <div className="w-16 h-16 bg-brand-primary/10 rounded-full flex items-center justify-center text-brand-primary">
            <ShieldAlert className="w-10 h-10" />
          </div>

          <div className="flex flex-col gap-2">
            <span className="text-brand-primary font-bold text-sm uppercase tracking-widest">Fejl 403</span>
            <h1 className="font-display text-3xl sm:text-4xl font-bold text-brand-dark leading-tight">
              Adgang nægtet
            </h1>
          </div>

          <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
            Du har ikke adgang til denne side. Hvis du mener, at dette er en fejl, bedes du kontakte os på telefonen eller vende tilbage til forsiden.
          </p>

          <div className="w-full border-t border-gray-100 pt-6 mt-2 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 bg-brand-primary hover:bg-brand-primary/90 text-white font-semibold px-6 py-3 rounded-full transition-all shadow-md w-full sm:w-auto"
            >
              <ArrowLeft className="w-4 h-4" />
              Tilbage til forsiden
            </Link>
            <a
              href="tel:+4529832959"
              className="inline-flex items-center justify-center gap-2 border border-gray-200 hover:border-brand-primary hover:text-brand-primary text-gray-600 font-semibold px-6 py-3 rounded-full transition-all w-full sm:w-auto"
            >
              <Phone className="w-4 h-4" />
              Ring til os
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
